const envBase = process.env.REACT_APP_BACKEND_URL;
const isLocal = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);
export const API = `${isLocal ? envBase : window.location.origin}/api`;
